import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const UpdateSubCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    category_id: '',
    name: '',
    status: '1'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [itemRes, catRes] = await Promise.all([
          getRequest(`sub-categories/${id}`),
          getRequest('categories'),
        ]);
        const item = itemRes?.data || {};
        setFormData({
          category_id: String(item.category_id ?? ''),
          name: item.name || '',
          status: String(item.status ?? '1')
        });
        setCategories(catRes?.data || []);
      } catch (err) {
        console.error('Failed to fetch sub category:', err);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await patchRequest(`sub-categories/${id}`, formData);
      toast.success('Sub category updated successfully!');
      navigate('/sub-categories');
    } catch (error) {
      console.error('Failed to update sub category:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Update Sub Category</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="category_id">Category</label>
              <select
                id="category_id"
                name="category_id"
                className="form-control"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateSubCategory;
